import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup } from "@mui/material";
import { useState } from "react";
import { Commons } from "../../helper/CommonService";
import { API_HOST } from "../../helper/Constant";
import LoadingButton from "@mui/lab/LoadingButton";
import { Save } from "@mui/icons-material";
import ShowNotif from "../general/ShowNotif";
import DialogCommonTitle from "./DialogCommonTitle";

function DialogProgress({ isOpen, handleClose, rowDetail, handleDataChange }) {
    const [loading, setLoading] = useState(false);
    const [isShowNotif, setIsShowNotif] = useState(false);
    const [notifData, setNotifData] = useState({});
    if (!rowDetail) {
        return (
            <></>
        )
    }

    const UpdateProgress = () => {
        setLoading(true);
        const { no_daftar, nama, ...result } = rowDetail;
        Commons.UpdateData(API_HOST + "/progress/" + rowDetail.id, result, true)
            .then((resUpdate) => {
                setNotifData({
                    status: "success",
                    message: "Berhasil Update Progress"
                });
            })
            .catch((resErr) => {
                setNotifData({
                    status: "error",
                    message: "Gagal Update Progress"
                });
                console.log(resErr);
            })
            .finally(() => {
                setIsShowNotif(true);
                setLoading(false);
            });
    }

    return (
        <>
            <ShowNotif isShow={isShowNotif} data={notifData} actionClose={() => { setIsShowNotif(false); }}></ShowNotif>
            <Dialog fullWidth maxWidth={"md"} open={isOpen} onClose={handleClose}>
                <DialogTitle>
                    <DialogCommonTitle dialogTitle={"Detail Progress Pendaftaran"} detailName={rowDetail.nama} noWa={rowDetail.waNo}></DialogCommonTitle>
                </DialogTitle>
                <DialogContent>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isIsi_formulir) ? true : false} name="isIsi_formulir" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Sudah isi formulir?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isBayar_pendaftaran) ? true : false} name="isBayar_pendaftaran" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Sudah Bayar Pendaftaran?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isUpload_berkas) ? true : false} name="isUpload_berkas" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Sudah Upload Berkas?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isBerkas_verified) ? true : false} name="isBerkas_verified" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Berkas sudah terverifikasi?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isUndangan_ujian) ? true : false} name="isUndangan_ujian" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Waktunya undangan Ujian?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isUjian_seleksi) ? true : false} name="isUjian_seleksi" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Mengikuti Ujian Seleksi?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isLulus) ? true : false} name="isLulus" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Lulus Ujian Seleksi?" />
                        <FormControlLabel control={<Checkbox checked={(rowDetail.isHasil_pengumuman) ? true : false} name="isHasil_pengumuman" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Waktunya diumumkan hasil Ujian?" />
                        <FormControlLabel disabled={(rowDetail.isLulus) ? false : true} control={<Checkbox checked={(rowDetail.isBayar_daftar_ulang) ? true : false} name="isBayar_daftar_ulang" onChange={(e) => { handleDataChange(e, rowDetail.id); }} />} label="Sudah bayar daftar ulang?" />
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loading={loading}
                        loadingPosition="start"
                        style={{ backgroundColor: "#e96726", color: "white" }}
                        startIcon={<Save />}
                        variant="outlined"
                        fullWidth
                        onClick={(e) => {
                            UpdateProgress();
                        }}
                    >
                        {loading ? "Processing" : "Update Progress"}
                    </LoadingButton>
                </DialogActions>
            </Dialog>

        </>
    )
}

export default DialogProgress;